/**
 * Feature flags.
 *
 * FILE_UPLOADS_ENABLED — attachments are stored in Cloudflare R2 and read
 * through short-lived signed URLs. Turned on now that the storage backend is
 * live; it stayed off while uploads went to local disk, which did not survive
 * a container redeploy.
 *
 * This gates the UI only — the "Upload file" button on the Files tab and the
 * paperclip in the activity composer. The server has its own switch,
 * FILE_UPLOADS_ENABLED in the backend environment, which must also be true or
 * the endpoints reject with a 503.
 */
export const FILE_UPLOADS_ENABLED = true;

/** Shown as the tooltip on the disabled upload controls. */
export const UPLOADS_DISABLED_MESSAGE =
  "File uploads are disabled until cloud storage is set up";
